module.exports = __webpack_public_path__ + "img/about_cladify.e0b5209f.png";